import { Grid } from '@material-ui/core'
import React from 'react'

interface Props {
  type: 'Creditor' | 'Recipient' | 'Buyer'
  data: any
}

export const InboundCompDetail = ({ type, data }: Props) => {
  const customCol1 = type === 'Recipient' ? 12 : 4
  const customCol2 = type === 'Buyer' ? 12 : 4

  const fieldConfig: Record<
    string,
    { label: string; key: keyof typeof data; colSize?: number }[]
  > = {
    Buyer: [
      { label: `Name`, key: data?.buyer_name },
      { label: `TIN`, key: data?.buyer_tin },
      { label: `ID No`, key: data?.buyer_regno },
      {
        label: `Identity Type`,
        key: data?.buyer_identity_type,
        colSize: 4,
      },
      {
        label: `SST Reg No`,
        key: data?.buyer_tax_regno,
        colSize: 4,
      },
      {
        label: `Contact No`,
        key: data?.buyer_contact_no,
        colSize: 4,
      },
      {
        label: `Email`,
        key: data?.buyer_email,
        colSize: customCol2,
      },
      {
        label: `Address 1`,
        key: data?.buyer_address1,
        colSize: null,
      },
      {
        label: `Address 2`,
        key: data?.buyer_address2,
        colSize: null,
      },
      {
        label: `Address 3`,
        key: data?.buyer_address3,
        colSize: null,
      },
      {
        label: `Country`,
        key: data?.buyer_country,
        colSize: 4,
      },
      {
        label: `State`,
        key: data?.BuyerState,
        colSize: 4,
      },
      {
        label: `State Code`,
        key: data?.buyer_state,
        colSize: 4,
      },
      {
        label: `City`,
        key: data?.buyer_city,
        colSize: 4,
      },
      {
        label: `Postcode`,
        key: data?.buyer_post_code,
        colSize: 4,
      },
    ],
    Creditor: [
      { label: `Name`, key: data?.company_name },
      { label: `TIN`, key: data?.company_tin },
      { label: `ID No`, key: data?.company_regno },
      {
        label: `Identity Type`,
        key: data?.company_identity_type,
        colSize: 4,
      },
      {
        label: `SST Reg No`,
        key: data?.company_tax_regno,
        colSize: 4,
      },
      {
        label: `Contact No`,
        key: data?.company_contact_no,
        colSize: 4,
      },
      {
        label: `Email`,
        key: data?.company_email,
        colSize: customCol2,
      },
      {
        label: `Address 1`,
        key: data?.company_address1,
        colSize: null,
      },
      {
        label: `Address 2`,
        key: data?.company_address2,
        colSize: null,
      },
      {
        label: `Address 3`,
        key: data?.company_address3,
        colSize: null,
      },
      {
        label: `Country`,
        key: data?.company_country,
        colSize: 4,
      },
      {
        label: `State`,
        key: data?.BuyerState,
        colSize: 4,
      },
      {
        label: `State Code`,
        key: data?.company_state,
        colSize: 4,
      },
      {
        label: `City`,
        key: data?.company_city,
        colSize: 4,
      },
      {
        label: `Postcode`,
        key: data?.company_post_code,
        colSize: 4,
      },
    ],
    Recipient: [
      { label: `Name`, key: data?.recipient_name },
      { label: `TIN`, key: data?.recipient_tin },
      { label: `ID No`, key: data?.recipient_regno },
      {
        label: `Identity Type`,
        key: data?.recipient_identity_type,
        colSize: customCol1,
      },
      {
        label: `SST Reg No`,
        key: data?.recipient_tax_regno,
        colSize: 4,
      },
      {
        label: `Contact No`,
        key: data?.recipient_contact_no,
        colSize: 4,
      },
      {
        label: `Email`,
        key: data?.recipient_email,
        colSize: customCol2,
      },
      {
        label: `Address 1`,
        key: data?.recipient_address1,
        colSize: null,
      },
      {
        label: `Address 2`,
        key: data?.recipient_address2,
        colSize: null,
      },
      {
        label: `Address 3`,
        key: data?.recipient_address3,
        colSize: null,
      },
      {
        label: `Country`,
        key: data?.recipient_country,
        colSize: 4,
      },
      {
        label: `State`,
        key: data?.recipient_state,
        colSize: 4,
      },
      {
        label: `State Code`,
        key: data?.recipient_state,
        colSize: 4,
      },
      {
        label: `City`,
        key: data?.recipient_city,
        colSize: 4,
      },
      {
        label: `Postcode`,
        key: data?.recipient_post_code,
        colSize: 4,
      },
    ],
  }

  return (
    <Grid container>
      {fieldConfig[type]?.map(({ label, key, colSize = 4 }) => (
        <Grid item sm={12} md={colSize}>
          <div className="content-wrap full">
            <div className="desc" style={{ color: 'grey' }}>
              {type} {label}
            </div>
            <div className="mdDesc">{key ?? '—'}</div>
          </div>
        </Grid>
      ))}
    </Grid>
  )
}
